const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal;
    this.isOpen = false;
    
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) {
          this.fetchHtml(productHandle);
        }
      }
    });
    
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) {
        MinimogTheme.ProductQuickView.close();
      }
    });
  }

  fetchHtml(productHandle) {
    loadAssets([MinimogThemeStyles.product], "quick-view-assets");
    
    fetchSection("product-quickview", {
      url: `${window.MinimogSettings.base_url}products/${productHandle}`
    }).then((response) => {
      this.modalContent = response.querySelector(".m-product-quickview");
      const productModel = response.querySelector("product-model");
      this.mediaGallery = this.modalContent.querySelector("media-gallery");
      
      loadAssets([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker], "variants-picker", () => {
        this.modal.appendChild(this.modalContent);
        this.modal.setWidth("1040px");
        this.modal.setSizes("m-modal-quickview");
        this.modal.open();
        this.toggleLoading(this.target, false);
        this.isOpen = true;
        
        // Dynamically load intercars script if present in response
        const intercarsScript = response.querySelector('script[src*="intercars-integration"]');
        if (intercarsScript && !document.querySelector('script[src*="intercars-integration"]')) {
            const script = document.createElement('script');
            script.src = intercarsScript.src;
            script.defer = true;
            document.head.appendChild(script);
        }
        
        // Initialize tooltips
        const tooltipElements = this.modalContent.querySelectorAll("[data-tippy-content]");
        if (tooltipElements) {
          tooltipElements.forEach((element) => {
            MinimogLibs.Tooltip(element, {
              theme: "minimog",
              touch: false,
              animation: "shift-toward"
            });
          });
        }
        
        // Initialize wishlist buttons state after quickview is loaded
        if (MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState) {
          MinimogTheme.Wishlist.setWishlistButtonsState();
        }
      });
      
      if (productModel) {
        loadAssets([MinimogThemeScripts.productModel, "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"], "product-model-assets");
      }
    }).catch(console.error);
  }

  close(event) {
    this.modal.close(event);
    this.isOpen = false;
  }

  toggleLoading(target, isLoading) {
    if (isLoading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView;